/* eslint-disable prefer-template */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// import logo from '../../../../shared/img/logo/logo_MW.png';
// import instaLogo from '../../../../shared/img/logo/insta_logo.png';

import examNameTranslation from '../../../../helpers/translateExamName';
import { formatMinutes } from '../../../../helpers/utils';

const addSlideExam = (pptx, addBrandingToSlide, year, index) => {
  // presentation slide
  const slideExam = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slideExam.addText(`EVALUATIONS ANNEE ${index + 1}`, {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616', // rouge foncé
      width: 1, // épaisseur de la bordure
    },
  });

  // Semestres impairs
  slideExam.addText(`Semestre ${year[0].semester}`, {
    x: 0.5,
    y: 1.5,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 15,
    color: 'fc1e1e',
    bold: true,
  });

  slideExam.addText(`Utilisation de la plateforme e-learning ${year[0].adminData?.ponderation ? `(${year[0].adminData.ponderation.elearning}%)` : ''}`, {
    x: 0.5,
    y: 2,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 14,
    color: '696969',
    bold: true,
  });

  slideExam.addShape(pptx.ShapeType.ellipse,
    {
      fill: {
        type: 'solid',
        color: '696969',
      },
      x: 0.65,
      y: 2.50,
      w: 0.05,
      h: 0.05,
    });
  slideExam.addText(`Taux de réussite des "Chapter Quiz": ${year[0].elearning.elearningTarget > 0 ? `${year[0].elearning.elearningTarget}%` : 'Non concerné'}`, {
    x: 0.75,
    y: 2.25,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 14,
    color: '4f4f4f',
  });
  slideExam.addShape(pptx.ShapeType.ellipse,
    {
      fill: {
        type: 'solid',
        color: '696969',
      },
      x: 0.65,
      y: 2.75,
      w: 0.05,
      h: 0.05,
    });
  slideExam.addText(`Taux de réalisation du programme: ${year[0].elearning.elearningAttempts > 0 ? `${year[0].elearning.elearningAttempts}%` : 'Non concerné'}`, {
    x: 0.75,
    y: 2.5,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 14,
    color: '4f4f4f',
  });

  slideExam.addShape(pptx.ShapeType.ellipse,
    {
      fill: {
        type: 'solid',
        color: '696969',
      },
      x: 0.65,
      y: 3,
      w: 0.05,
      h: 0.05,
    });
  slideExam.addText(`Temps de connexion: ${year[0].elearning.elearningDurationTarget > 0 ? `${year[0].elearning.elearningDurationTarget}%` : 'Non concerné'} ${year[0].elearning.elearningDurationTarget > 0 ? `(${formatMinutes((year[0].elearning.elearningDuration / 100) * year[0].elearning.elearningDurationTarget)})` : ''}`, {
    x: 0.75,
    y: 2.75,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 14,
    color: '4f4f4f',
  });
  if (year[0]?.elearning?.elearningOptions && year[0]?.elearning?.elearningOptions.length > 0) {
    year[0]?.elearning?.elearningOptions.forEach((exam) => {
      if (!exam.catchUp && exam.modality !== 'Oral - Participation') {
        const examItem = examNameTranslation(exam.modality, year[0].semester, exam.duration);
        slideExam.addText(examItem?.name + (year[0].adminData?.ponderation ? (' (' + year[0].adminData.ponderation.exams + '%)') : '') || '', {
          x: 0.5,
          y: 3.25,
          w: 5,
          h: 0.5,
          align: 'left',
          fontSize: 14,
          color: '696969',
          bold: true,
        });
        slideExam.addText(examItem.summary || '', {
          x: 0.5,
          y: 3.50,
          w: 5,
          h: 0.5,
          align: 'left',
          fontSize: 14,
          color: '696969',
        });
        let y1 = 3.75;
        examItem.grades?.forEach((grade) => {
          slideExam.addShape(pptx.ShapeType.ellipse,
            {
              fill: {
                type: 'solid',
                color: '696969',
              },
              x: 0.65,
              y: y1 + 0.25,
              w: 0.05,
              h: 0.05,
            });
          slideExam.addText(grade, {
            x: 0.75,
            y: y1,
            w: 5,
            h: 0.5,
            align: 'left',
            fontSize: 14,
            color: '696969',
          });
          y1 += 0.25;
        });
      }
    });
  }

  if (year[1]) {
    // Semestres pairs
    slideExam.addText(`Semestre ${year[1].semester}`, {
      x: 5.5,
      y: 1.5,
      w: 4,
      h: 0.5,
      align: 'left',
      fontSize: 15,
      color: 'fc1e1e',
      bold: true,
    });

    slideExam.addText(`Utilisation de la plateforme e-learning ${year[1].adminData?.ponderation ? `(${year[1].adminData.ponderation.elearning}%)` : ''}`, {
      x: 5.5,
      y: 2,
      w: 5,
      h: 0.5,
      align: 'left',
      fontSize: 14,
      color: '696969',
      bold: true,
    });

    slideExam.addShape(pptx.ShapeType.ellipse,
      {
        fill: {
          type: 'solid',
          color: '696969',
        },
        x: 5.65,
        y: 2.50,
        w: 0.05,
        h: 0.05,
      });
    slideExam.addText(`Taux de réussite des "Chapter Quiz": ${year[1].elearning.elearningTarget > 0 ? `${year[1].elearning.elearningTarget}%` : 'Non concerné'}`, {
      x: 5.75,
      y: 2.25,
      w: 5,
      h: 0.5,
      align: 'left',
      fontSize: 14,
      color: '4f4f4f',
    });
    slideExam.addShape(pptx.ShapeType.ellipse,
      {
        fill: {
          type: 'solid',
          color: '696969',
        },
        x: 5.65,
        y: 2.75,
        w: 0.05,
        h: 0.05,
      });
    slideExam.addText(`Taux de réalisation du programme: ${year[1].elearning.elearningAttempts > 0 ? `${year[1].elearning.elearningAttempts}%` : 'Non concerné'}`, {
      x: 5.75,
      y: 2.5,
      w: 5,
      h: 0.5,
      align: 'left',
      fontSize: 14,
      color: '4f4f4f',
    });

    slideExam.addShape(pptx.ShapeType.ellipse,
      {
        fill: {
          type: 'solid',
          color: '696969',
        },
        x: 5.65,
        y: 3,
        w: 0.05,
        h: 0.05,
      });
    slideExam.addText(`Temps de connexion: ${year[1].elearning.elearningDurationTarget > 0 ? `${year[1].elearning.elearningDurationTarget}%` : 'Non concerné'} ${year[1].elearning.elearningDurationTarget > 0 ? `(${formatMinutes((year[1].elearning.elearningDuration / 100) * year[1].elearning.elearningDurationTarget)})` : ''}`, {
      x: 5.75,
      y: 2.75,
      w: 5,
      h: 0.5,
      align: 'left',
      fontSize: 14,
      color: '4f4f4f',
    });
    if (year[1]?.elearning?.elearningOptions && year[1]?.elearning?.elearningOptions.length > 0) {
      year[1]?.elearning?.elearningOptions.forEach((exam) => {
        if (!exam.catchUp && exam.modality !== 'Oral - Participation') {
          const examItem = examNameTranslation(exam.modality, year[1].semester, exam.duration);
          slideExam.addText(examItem.name + (year[1].adminData?.ponderation ? (' (' + year[1].adminData.ponderation.exams + '%)') : '') || '', {
            x: 5.5,
            y: 3.25,
            w: 5,
            h: 0.5,
            align: 'left',
            fontSize: 14,
            color: '696969',
            bold: true,
          });
          slideExam.addText(examItem.summary || '', {
            x: 5.5,
            y: 3.50,
            w: 5,
            h: 0.5,
            align: 'left',
            fontSize: 14,
            color: '696969',
          });
          let y2 = 3.75;
          examItem.grades?.forEach((grade) => {
            slideExam.addShape(pptx.ShapeType.ellipse,
              {
                fill: {
                  type: 'solid',
                  color: '696969',
                },
                x: 5.65,
                y: y2 + 0.25,
                w: 0.05,
                h: 0.05,
              });
            slideExam.addText(grade, {
              x: 5.75,
              y: y2,
              w: 5,
              h: 0.5,
              align: 'left',
              fontSize: 14,
              color: '696969',
            });
            y2 += 0.25;
          });
        }
      });
    }
  }

  addBrandingToSlide(pptx, slideExam);
};

export default addSlideExam;
